import React from 'react';
import { useAdminEdit } from '../context/AdminEditContext';
import { Pencil, Check } from 'lucide-react';

const AdminEditToolbar = () => {
  const { isAdmin, editMode, setEditMode } = useAdminEdit();
  if (!isAdmin) return null;
  return (
    <button
      onClick={() => setEditMode(!editMode)}
      className={`fixed bottom-6 left-6 z-[60] flex items-center gap-2 px-4 py-3 rounded-full shadow-lg font-medium text-sm transition-colors
        ${editMode ? 'bg-[#C75B27] text-white' : 'bg-[#1F4D3F] text-white hover:bg-[#173B30]'}`}
      title={editMode ? 'Désactiver le mode édition' : 'Activer le mode édition'}
    >
      {editMode ? <><Check className="w-4 h-4" /> Édition activée</> : <><Pencil className="w-4 h-4" /> Mode édition</>}
    </button>
  );
};

export default AdminEditToolbar;
